/** @param {string} date */
export function formatDate(date) {
  const asDate = new Date(date)
  return new Intl.DateTimeFormat(navigator.language).format(asDate)
}
